import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getRemoteConfig } from "firebase/remote-config";

const firebaseConfig = {
  apiKey: "AIzaSyCq1Ci-3Hb1urorX1cjtGvhcINxGkolxIY",
  authDomain: "gojourneyapp.firebaseapp.com",
  databaseURL: "https://gojourneyapp-default-rtdb.firebaseio.com",
  projectId: "gojourneyapp",
  storageBucket: "gojourneyapp.appspot.com",
  messagingSenderId: "1014138978423",
  appId: "1:1014138978423:web:9b03b2ed5eaf6bbe954672",
  measurementId: "G-4VHWWSM925",
};

// const firebaseConfigDevelop = {
//   apiKey: "AIzaSyCN-V4tH3t3ECV8p22E3ctiRQjkgmPDgGs",
//   authDomain: "journey-staging-7f30b.firebaseapp.com",
//   databaseURL: "https://journey-staging-7f30b-default-rtdb.firebaseio.com",
//   projectId: "journey-staging-7f30b",
//   storageBucket: "journey-staging-7f30b.appspot.com",
//   messagingSenderId: "512308170929",
//   appId: "1:512308170929:web:b38975f722294c83f15290",
//   measurementId: "G-V9VRWRB35H",
// };

const firebaseConfigDevelop = {
  apiKey: "AIzaSyCN-V4tH3t3ECV8p22E3ctiRQjkgmPDgGs",
  authDomain: "journey-staging-7f30b.firebaseapp.com",
  databaseURL: "https://journey-staging-7f30b-default-rtdb.firebaseio.com",
  projectId: "journey-staging-7f30b",
  storageBucket: "journey-staging-7f30b.appspot.com",
  messagingSenderId: "512308170929",
  appId: "1:512308170929:web:b38975f722294c83f15290",
  measurementId: "G-0W2Q2WR1N1",
};

// Initialize Firebase
export const app = initializeApp(
  process.env.REACT_APP_FIREBASE_CONFIG === "production"
    ? firebaseConfig
    : firebaseConfigDevelop
);
// init firebase analytics
export const analytics = getAnalytics(app);
export const remoteConfig = getRemoteConfig(app);

remoteConfig.settings.minimumFetchIntervalMillis = 0;

remoteConfig.defaultConfig = {
  onboarding_welcome_enabled: false,
  experiments: "onboarding_welcome_enabled, onboarding_paywall_id",
  onboarding_paywall_id: "1",
  onboarding_ask_email_type:
    '{"title":"One last step, so we can finalize your results!","text":[{"content":"Enter your email ", "bold": true}, {"content":"to receive the personal sleepscape plan and get the one-time offer of "}, {"content":"30% off ", "bold": true}, {"content":"of Journey Premium."}]}',
  appstore_link: "https://gojourney.page.link/fromweb",
  onboarding_sleep_story_enabled: true,
  onboarding_sleepsounds_enabled: true,
  paid_trial_enabled: true,
  paypal_enabled: true,
  paywall_offer_id: "30_1month15-1year70_dark",
};
